export const statusText: { [x: string]: string } = {
	notPayed: 'Не оплачена',
	confirmed: 'Подтерждена',
	cancelled: 'Отменена',
	awaitingPayment: 'Ожидает оплаты',
	unconfirmed: 'Не подтерждена',
};
